// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld-base';
import './layerEditor';

myw.EsriLayerEditor = myw.LayerEditor.extend({
    messageGroup: 'DefineLayerControl',
    tabs: [
        {
            id: 'properties-layers-tab',
            title: '{:properties}'
        },
        {
            id: 'advanced-layers-tab',
            title: '{:advanced}'
        },
        {
            id: 'general-layers-tab',
            title: '{:general}'
        }
    ],

    renderAdvanced(table) {
        const rowDefs = [
            {
                label: '{:esriMap}:',
                components: [new myw.Input({ name: 'esriMap' })]
            },
            {
                label: '{:authType}:',
                components: [new myw.Dropdown({ name: 'authType', options: ['', 'token', 'ntlm'] })]
            },
            {
                label: '{:username}:',
                components: [new myw.Input({ name: 'username' })]
            },
            {
                label: '{:password}:',
                components: [new myw.Input({ name: 'password' })]
            },
            {
                label: '{:verifySsl}:',
                components: [new myw.Checkbox({ name: 'verifySsl' })]
            },
            {
                label: '{:esriUseJsonp}:',
                components: [new myw.Checkbox({ name: 'esriUseJsonp' })]
            },
            {
                name: 'control_item_legend',
                label: '{:control_item_legend}:',
                components: [new myw.Checkbox({ name: 'control_item_legend' })]
            }
        ];

        this._renderRows(table, rowDefs);
    },

    formValuesToLayerDef(formValues) {
        const def = myw.LayerEditor.prototype.formValuesToLayerDef.call(this, formValues);
        _.extend(
            def.datasource_spec,
            _.pick(
                formValues,
                'url',
                'verifySsl',
                'esriUseJsonp',
                'username',
                'password',
                'authType'
            )
        );
        def.esriMap = formValues.esriMap;
        return def;
    }
});

myw.layerEditors['esri'] = myw.EsriLayerEditor;

export default myw.EsriLayerEditor;
